import { useTranslation } from 'react-i18next';

const STEPS = [
  { num: '01', icon: 'ri-search-line', titleKey: 'how.s1.title', descKey: 'how.s1.desc' },
  { num: '02', icon: 'ri-scales-3-line', titleKey: 'how.s2.title', descKey: 'how.s2.desc' },
  { num: '03', icon: 'ri-shield-check-line', titleKey: 'how.s3.title', descKey: 'how.s3.desc' },
  { num: '04', icon: 'ri-checkbox-circle-line', titleKey: 'how.s4.title', descKey: 'how.s4.desc' },
];

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section id="how" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            {t('how.title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">{t('how.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((step) => (
            <div
              key={step.num}
              className="relative rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <span className="absolute top-5 right-5 font-heading font-extrabold text-3xl text-background-200">
                {step.num}
              </span>
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 mb-4">
                <i className={`${step.icon} text-2xl`} />
              </span>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">
                {t(step.titleKey)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{t(step.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}